import React from 'react'
import { Typography } from 'react-components'
import { DottedSeparator, SectionTitleWrapper } from '../styles'
import { CostList, CostRow } from './styles'
import { useTranslation } from '../../../hooks/locale'
import { FormattedLivePricingDataTransport } from '../../../models/pricing/live-pricing-formatter'

type OnSiteCostsProps = {
    inclusiveCosts?: FormattedLivePricingDataTransport['inclusiveCosts']
}

const OnSiteCosts: React.FC<OnSiteCostsProps> = ({ inclusiveCosts }) => {
    const { t } = useTranslation()

    const onSiteCosts = inclusiveCosts?.filter(cost => !cost.includedInBillingAmount && cost.price) ?? []
    if (onSiteCosts.length === 0) {
        return null
    }

    return (
        <>
            <DottedSeparator />
            <SectionTitleWrapper>
                <Typography variant="subtitle1" fontWeight="bold">
                    {t('price.onSiteCosts.title')}
                </Typography>
            </SectionTitleWrapper>
            <CostList>
                {onSiteCosts.map((cost, index) => (
                    <CostRow key={`${index}-${cost.name}`}>
                        <Typography variant="subtitle2" fontWeight="regular" color="tfwBlack40">
                            {cost.name}
                        </Typography>
                        <Typography variant="subtitle2" fontWeight="regular" color="tfwBlack40">
                            {cost.price}
                        </Typography>
                    </CostRow>
                ))}
            </CostList>
        </>
    )
}

export default OnSiteCosts
